const styles = (theme) => ({
  checkIcon: {
    color: theme.palette.success.main,
  },
  hover: {
    cursor: 'pointer',
  },
});

export default styles;
